import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { ButtonComponent } from '../../shared';
import { BackArrow, GreenPlus, IconPlus } from '../../../assets/svg';
import useWindowSize from '../../../hooks/useWindowSize';

export const Heading = ({
    data,
    heading = '',
    showAddButton,
    handleAddClick,
    addButtonText,
    addButtonIcon,
    accountName = ''
}) => {
    const navigate = useNavigate();
    const { width } = useWindowSize();
    const handleBackButton = () => {
        navigate(-1);
    };
    return (
        <div className='title-btn mt-1 d-flex align-items-center border-0 bg-white'>
            <ButtonComponent
                className='d-flex align-items-center border-0 bg-white'
                type='button'
                clickHandler={handleBackButton}
            >
                <BackArrow />
            </ButtonComponent>
            <div className='d-flex w-100 justify-content-between align-items-center '>
                <span className='justify-content-start'>{heading}</span>
                <span className='d-flex align-items-center'>
                    <span className='justify-content-end edit-customer-heading font-16px me-4'>
                        {data?.account?.name || accountName}
                    </span>
                    {showAddButton && (
                        <span className='d-flex gap-2'>
                            {width > 590 ? (
                                <button
                                    className='ssc-secondary-white-btn text-nowrap'
                                    type='button'
                                    data-bs-toggle='modal'
                                    data-bs-target='#exampleModal-add'
                                    style={{
                                        height: '36px',
                                        fontSize: '14px',
                                        color: 'var(--col-btn-primary)',
                                    }}
                                    onClick={handleAddClick}
                                >
                                    {addButtonIcon ? addButtonIcon : <GreenPlus />}
                                    <p>{addButtonText}</p>
                                </button>
                            ) : (
                                <span
                                    id='action-btn-green'
                                    title={addButtonText}
                                    onClick={handleAddClick}
                                >
                                    {addButtonIcon ? addButtonIcon : <IconPlus />}
                                </span>
                            )}
                        </span>
                    )}
                </span>
            </div>
        </div>
    );
};
Heading.propTypes = {
    data: PropTypes.object,
    heading: PropTypes.string,
};
